<div class="header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  @if (allowNew) {
    <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
      <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
    </button>
  }
</div>

<div class="header d-flex d-md-none align-items-center excel-header-wrap">
  <h1 class="w-100">{{ title | translate }}</h1>
  @if (allowNew) {
    <button class="btn btn-outlined" (click)="onCreateItem()">
      <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
    </button>
  }
</div>

@if (helpText) {
  <div class="row">
    <div class="col-12">
      <app-information-block [text]="helpText | translate"></app-information-block>
    </div>
  </div>
}

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

@if (itemsSource) {
  <app-paged-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [itemsSource]="itemsSource"
    [totalCount]="totalResults"
    [pageNumber]="pageNumber"
    [itemsPerPage]="pageSize"
    [preferencesKey]="preferencesKey"
    (onPageChange)="pagingChanged($event)"
    (onSortChange)="sortChanged($event)"
    (onColumnChange)="onColumnChange($event)"
    (onSelectedIdsChange)="onSelectedIdsChange($event)"
    (onDeselectedIdsChange)="onDeselectedIdsChange($event)"
    (onAffectedItemsCountChange)="onAffectedItemsCountChange($event)"
    (onAllSelectedChange)="onAllSelectedChange($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    >
  </app-paged-list-view>
}

<ng-template #createAmortizationPlanSidebar>
  <app-create-amortization-plan-sidebar
    [invoiceIds]="amortizationPlanInvoiceIds"
    [selectContactFirst]="selectAmortizationPlanContactFirst"
    (created)="onAmortizationPlanCreated()"
    (canceled)="closeAmortizationPlanSidebar()"
  ></app-create-amortization-plan-sidebar>
</ng-template>

<ng-template #createPaymentNoticeSidebar>
  <app-create-amortization-plan-payment-notice-sidebar
    [amortizationPlanIds]="selectedAmortizationPlanIds"
    (created)="onPaymentNoticesCreated()"
    (canceled)="closePaymentNoticeSidebar()"
  ></app-create-amortization-plan-payment-notice-sidebar>
</ng-template>
